import { render, staticRenderFns } from "./LastStep.vue?vue&type=template&id=03caffc9&"
import script from "./LastStep.vue?vue&type=script&lang=js&"
export * from "./LastStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports